<!-- IIT2-1439-start -->
<div class="fade show partner_content" id="partnerContent">
  <div class="view_partner_data" id="viewPartnerData">
    <div class="title_bar" id="titleBar">
      <img class="page_back_icon" alt="go back" (click)="goBackToApprove()" />
      <span class="title">{{contentName}}</span>
    </div>

      <!-- Section 1 - Model SKU Info -->
      <section>
        <div class="section_header" id="skuSectionHeader">
          <img class="sku" alt="modelSKU" />
          <span i18n="@@approved-partner-content-view.header.Model-SKU-Info">MODEL SKU INFO</span>
        </div>
        <div class="section_body model_info_section" id="modelInfoSec">
          <div class="info_group" id="infoGrpSystemId">
            <label> <span i18n="@@approved-partner-content-view.info-section.systemId">System ID</span></label>
            <span>{{systemID}}</span>
          </div>
          <div class="info_group" style="max-width: 535px" id="infoGrpDisplayName">
            <label> <span i18n="@@approved-partner-content-view.info-section.displayName">Display Name</span></label>
            <span>
              <ng-container *ngIf="displayVal.length">
                <ng-container *ngFor="let data of displayVal, let i = index, let c = count">
                  {{i < c-1 ? (data + ' - ' + displayLang[i] + ', ' ) : data + ' - ' + displayLang[i]}} </ng-container>
                </ng-container>
                <ng-container *ngIf="!displayVal.length">
                  {{disvalue}} - {{englishLang}}
                </ng-container>
            </span>
          </div>
          <div id="infoGrpMainDiv">
            <div class="info_group" id="infoGrpSystemModels">
              <label> <span i18n="@@approved-partner-content-view.info-section.systemModels">System Models</span> </label>
            </div>
            <div class="info_group" *ngIf="this.configurations?.publishTime?.length" id="infoGrpPublishTime">
              <div id="publishDateTime">
                <label><span i18n="@@segments.expanded-segment.publish-date">Publishing Date and Time</span></label>
                <div id="publishTimeDateFormat">
                  {{this.configurations?.publishTime| dateFormat: "24hrP" }}
                </div>
              </div>
              <div class="mt-2" *ngIf="this.configurations?.expireTime?.length" id="expireTimeDateMain">
                <label><span i18n="@@segments.expanded-segment.expire-date">Expiration Date and Time</span></label>
                <div id="expireTimeDateFormat">
                  {{this.configurations?.expireTime| dateFormat: "24hrP" }}
                </div>
              </div>
            </div>
            <div class="info_group_chip" id="infoGrpChip">
              <ng-container *ngIf="!singleData">
                <ng-container *ngFor="let data of parsedData">
                  <span class="chip">{{data}}</span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="singleData">
                <span class="chip">{{parsedData}}</span>
              </ng-container>
            </div>
        </div>
      </div>
      <div class="boldClass" id="operatingSystemSec">
        <label><span i18n="@@approved-partner-content-view.info-section.OS">Operating System</span></label>
        <span>{{operatingSystem}}</span>
      </div>
      </section>

      <!-- Section 2 - Language -->
      <section>
        <div class="section_header" id="sectionHeader">
          <img
            class="lang"
            alt=""
          />
          <span i18n = "@@approved-partner-content-view.header.language">LANGUAGE</span>
        </div>
        <div class="section_body" id="secionBody">
          <div class="info_group" id="infoGrpLangCategory">
            <label><span i18n = "@@approved-partner-content-view.info-group.languageCategory">Language Category</span></label>
            <span>{{languageCategory}}</span>
          </div>
          <div class="info_group" id="infoGrpLangPartner">
            <label><span i18n = "@@approved-partner-content-view.info-group.Languages">Languages</span></label>
            <span>{{displayLanguage}}</span>
          </div>
        </div>
      </section>

    <!-- Section 3 - tile thumbnail -->
    <section>
      <div class="section_header" id="sectionHeader3">
        <img class="thumbnail" alt="" />
        <span i18n = "@@approved-partner-content-view.header.tilethumbnail">TILE THUMBNAIL</span>
      </div>
      <div class="section_body" id="sectionBody3">
        <!-- get this image from api -->
        <img class="reduceMinHeight" [src]="imageUrl" alt="thumbnail" />
      </div>
    </section>

    <!-- Section 4 - Pages -->
    <section>
      <div class="section_header" id="sectionHeader4">
        <img class="page" alt="language" />
        <span i18n = "@@approved-partner-content-view.header.pages">PAGES</span>
      </div>
      <div class="section_body pages_preview" *ngIf="contentGroupPages.length > 0" id="sectionBody4PagePreview">
        <iposcen-pages-view [configData]="contentGroupPages" [autoID]="autoID"></iposcen-pages-view>
      </div>
    </section>
    <section *ngIf="hasComments">
      <div class="section_header" id="sectionHeaderCommentMain">
        <img class="chat_quote" alt="provide comments" />
        <span i18n = "@@approved-partner-content-view.header.comments">COMMENTS</span>
      </div>
      <div class="section_body" id="sectionBodyCommentChild">
        <div class="comments_provided">
          {{comments}}
        </div>
      </div>
    </section>
  </div>
</div>
<!-- IIT2-1439-end -->